import { InvoicesError } from '@/lib/Errors';
import _axios from '@/plugins/axios';
export default {
	async getInvoiceReferencesForOrganization (organizationId) {
		const headers = { headers: { organizationId: organizationId } };
		const response = await _axios.get('invoice/getinvoicereferencesfororganization', headers);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new InvoicesError('No meta data!');
	},
	async getInvoices () {
		const response = await _axios.get('invoice/getinvoices');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new InvoicesError('No meta data!');
	},
	async generateInvoiceForOrganization (body) {
		const response = await _axios.post('invoice/generateinvoicefororganization', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new InvoicesError('No meta data!');
	},
	async updateInvoiceForOrganization (body) {
		const response = await _axios.put('invoice/updateinvoicefororganization', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new InvoicesError('No meta data!');
	},
	async getInvoicePdf (object) {
		const response = await _axios({
			url: 'invoice/getinvoicepdf',
			method: 'GET',
			responseType: 'blob',
			headers: {
				invoiceId: object.invoiceId,
			},
		});
		if (response.status === 200) {
			return response;
		}
		throw new InvoicesError('No summary!');
	},
	async deleteInvoice (id) {
		const response = await _axios.delete(`invoice/${id}`);
		if (response.data.resFlag) {
			const userJson = response.data;
			return userJson;
		} else {
			throw new InvoicesError('Invalid id');
		}
	},
	async getContactInvoicesEmails (id) {
		const response = await _axios.get('invoice/getContactInvoicesEmails', { headers: { invoiceId: id } });
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new InvoicesError('No meta data!');
	},
	async sendInvoiceByMailById (id, toEmails) {
		const response = await _axios.post(
			'invoice/sendinvoicebymailbyid',
			{},
			{
				params: { toEmails: toEmails },
				headers: { invoiceId: id },
			},
		);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new InvoicesError('No meta data!');
	},
	async changeInvoiceStatus (invoiceId, status) {
		const response = await _axios.post(
			'invoice/changeinvoicestatus',
			{},
			{
				params: { invoiceStatus: status },
				headers: { invoiceId: invoiceId },
			},
		);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new InvoicesError('No meta data!');
	},
	async sendMultipleAttachmentsByMail (payload) {
		const response = await _axios.post('invoice/sendMultipleAttachmentsByMail', payload.formData, {
			headers: {
				toEmails: payload.toEmails,
				ccEmails: payload.ccEmails,
				emailSubject: payload.emailSubject,
				'Content-Type': 'multipart/form-data',
			},
		});
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new InvoicesError(response.data.resMessage || 'Failed to send email');
	},
};
